import styled from 'styled-components';

export const MenuContainer = styled.div`
  margin-top: 5rem;
  & ul {
    margin: 0;
    & li {
      padding-top: 0.375rem;
      margin-top: 0.125rem;
    }
  }
`;

export const DownloadAreaItem = styled.div`
  display: flex;

  & > span.tag {
    position: relative;
    width: 3.2rem;
    height: 1.5rem;
    font-size: 0.875rem;
    line-height: 1.375rem;
    margin-left: 0.5rem;
    padding: 0 0.5rem;
    border-radius: 5rem;
    bottom: 0.5rem;
    background-color: ${({ theme }) => theme.colors.lightGray2};
    color: ${({ theme }) => theme.colors.black};
    text-align: center;
  }
`;
